var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{
    section: true,
    'section-image-info': true,
    [`section${_vm.orderNo}`]: true
  }},[_c('a',{staticClass:"navigation-target",attrs:{"id":_vm.hash,"href":"javascript:void(0);"}}),_vm._v(" "),_c('OrganismsCommonOrganismImageInfo',{attrs:{"list-image-info":_vm.data.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }